<template>
  <Link
    :href="route('cart.lines.apply-coupon', [id])"
    :class="color"
    :text="text"
    preserve-scroll
    class="button button--ghost"
    method="post"
    as="button"
  />
</template>

<script setup>
import Link from 'Web/Shared/Link.vue';
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  theme: {
    type: String,
    default: 'default',
  },
  text: {
    type: String,
    default: 'Abo anwenden',
  },
});

const color = computed(() => ({
  default: 'text-blue-500',
  pga:     'text-pga-500',
  pgb:     'text-pgb-500',
  pgc:     'text-pgc-500',
  pgd:     'text-pgd-500',
}[props.theme ?? 'default']));

</script>

